var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategoryTopOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(0.0735387 0.5em 0.5em)",
    rx: "0.013em",
    strokeWidth: "0.025em",
    stroke: "#5E5E5E",
    height: "0.95em",
    width: "0.95em",
    y: "0.027em",
    x: "0.025em",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: "0.013em",
    strokeWidth: "0.025em",
    height: "0.175em",
    width: "0.175em",
    y: "0.102em",
    x: "0.108em",
    stroke: "#5E5E5E",
    fill: "#1789ef"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: "0.013em",
    strokeWidth: "0.025em",
    height: "0.175em",
    width: "0.175em",
    y: "0.102em",
    x: "0.418em",
    stroke: "#5E5E5E",
    fill: "#1789ef"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: "0.013em",
    strokeWidth: "0.025em",
    height: "0.175em",
    width: "0.175em",
    y: "0.101em",
    x: "0.712em",
    stroke: "#5E5E5E",
    fill: "#1789ef"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.428em",
    x2: "0.896em",
    y1: "0.428em",
    x1: "0.104em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.562em",
    x2: "0.896em",
    y1: "0.562em",
    x1: "0.104em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.696em",
    x2: "0.894em",
    y1: "0.696em",
    x1: "0.102em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.828em",
    x2: "0.896em",
    y1: "0.828em",
    x1: "0.104em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryTopOrder);
export default __webpack_public_path__ + "static/media/categoryTopOrder.7f646e9fae67cf1852c5876eece748d0.svg";
export { ForwardRef as ReactComponent };